import RelatedContent from './RelatedContent';

export default RelatedContent;
